const DEFAULT_COLUMN_MAP = {
    xxxl: 4,
    xxl: 3,
    xl: 3,
    lg: 3,
    md: 3,
    sm: 2,
    xs: 1,
};
export default DEFAULT_COLUMN_MAP;
